import { Link } from "react-router-dom";
import { FaCheckCircle, FaStar, FaPhone, FaArrowRight } from "react-icons/fa";
import Carousel from "../components/Carousel";
import ShareButtons from "../components/ShareButtons";
import styles from "../styles/pages.module.css";

export default function Home() {

  const carouselImages = [
    { src: "/assets/images/carousel-1.webp", caption: "Empezamos con cuidado", subtitle: "Embalaje profesional para cada pieza de tu hogar" },
    { src: "/assets/images/carousel-2.webp", caption: "Te acompañamos en el camino", subtitle: "Hacemos fácil el momento más importante" },
    { src: "/assets/images/carousel-3.webp", caption: "Tu nuevo hogar te espera", subtitle: "Entregamos las llaves con total tranquilidad" },
    { src: "/assets/images/carousel-4.webp", caption: "Expertos en Madrid", subtitle: "Conocemos cada rincón de la ciudad" },
    { src: "/assets/images/carousel-5.webp", caption: "Listo para tu nueva etapa", subtitle: "Tu casa instalada al detalle" }
  ];

  return (
    <div style={{ background: "#FAF7F2" }}>
      <section className={styles.heroElegant}>
        <div className={styles.heroGrid}>
          <div className={styles.heroText}>
            <div className={styles.heroBadge}>
              <FaStar /> <span>25 años de experiencia</span>
            </div>
            <h1>
              Mudanzas en Madrid,<br/>
              <span className={styles.heroAccent}>sin estrés.</span>
            </h1>
            <p className={styles.heroLead}>
              Nos encargamos de todo: embalaje, transporte y montaje.
              Tú solo disfruta de tu nuevo hogar.
            </p>
            <div className={styles.heroCtas}>
              <Link to="/presupuesto" className={styles.btnPrimary}>
                Presupuesto gratis <FaArrowRight />
              </Link>
              <a href="tel:+34691604880" className={styles.btnGhost}>
                <FaPhone /> 691 60 48 80
              </a>
            </div>
          </div>
          <div className={styles.heroCarousel}>
            <Carousel images={carouselImages} />
            <img src="/assets/images/logo-icon.png" alt="Britosa" className={styles.heroLogoBadge} />
          </div>
        </div>
      </section>

      <section className={styles.trustBar}>
        <div className={styles.container}>
          <div className={styles.trustGrid}>
            <div className={styles.trustItem}>
              <div className={styles.trustNumber}>25<span>+</span></div>
              <div className={styles.trustLabel}>Años trabajando</div>
            </div>
            <div className={styles.trustItem}>
              <div className={styles.trustNumber}>1.200<span>+</span></div>
              <div className={styles.trustLabel}>Mudanzas realizadas</div>
            </div>
            <div className={styles.trustItem}>
              <div className={styles.trustNumber}>4,9<span>★</span></div>
              <div className={styles.trustLabel}>Valoración media</div>
            </div>
            <div className={styles.trustItem}>
              <div className={styles.trustNumber}>100<span>%</span></div>
              <div className={styles.trustLabel}>Asegurado</div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.servicesElegant}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <span className={styles.eyebrow}>Nuestros servicios</span>
            <h2>Una mudanza hecha a tu medida</h2>
            <p>Desde un estudio en Móstoles hasta un traslado internacional — lo resolvemos.</p>
          </div>
          <div className={styles.servicesElegantGrid}>
            <article className={styles.serviceCard}>
              <span className={styles.serviceNumber}>01</span>
              <h3>Mudanzas locales</h3>
              <p>Móstoles, Madrid y toda la zona metropolitana. Rapidez y cuidado en cada detalle.</p>
              <Link to="/servicios" className={styles.serviceLink}>Saber más →</Link>
            </article>
            <article className={styles.serviceCard}>
              <span className={styles.serviceNumber}>02</span>
              <h3>Mudanzas nacionales</h3>
              <p>Cubrimos toda España con rutas optimizadas y seguimiento permanente.</p>
              <Link to="/servicios" className={styles.serviceLink}>Saber más →</Link>
            </article>
            <article className={styles.serviceCard}>
              <span className={styles.serviceNumber}>03</span>
              <h3>Mudanzas de empresa</h3>
              <p>Oficinas, locales y espacios comerciales. Sin interrumpir tu actividad.</p>
              <Link to="/servicios" className={styles.serviceLink}>Saber más →</Link>
            </article>
            <article className={styles.serviceCard}>
              <span className={styles.serviceNumber}>04</span>
              <h3>Guardamuebles</h3>
              <p>Almacenamiento seguro y climatizado, con acceso flexible cuando lo necesites.</p>
              <Link to="/servicios" className={styles.serviceLink}>Saber más →</Link>
            </article>
          </div>
        </div>
      </section>

      <section className={styles.process}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <span className={styles.eyebrow}>Cómo trabajamos</span>
            <h2>Tu mudanza en 4 pasos</h2>
          </div>
          <div className={styles.processGrid}>
            <div className={styles.processStep}>
              <div className={styles.processCircle}>1</div>
              <h4>Presupuesto gratis</h4>
              <p>Cuéntanos qué necesitas. Respuesta en menos de 24h.</p>
            </div>
            <div className={styles.processStep}>
              <div className={styles.processCircle}>2</div>
              <h4>Planificación</h4>
              <p>Coordinamos la fecha y todos los detalles contigo.</p>
            </div>
            <div className={styles.processStep}>
              <div className={styles.processCircle}>3</div>
              <h4>El gran día</h4>
              <p>Embalamos, cargamos y transportamos con cuidado.</p>
            </div>
            <div className={styles.processStep}>
              <div className={styles.processCircle}>4</div>
              <h4>Instalación</h4>
              <p>Montamos y colocamos todo en tu nueva casa.</p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.reasons}>
        <img src="/assets/images/logo-icon.png" alt="" className={styles.sectionWatermark} />
        <div className={styles.container}>
          <div className={styles.reasonsGrid}>
            <div className={styles.reasonText}>
              <span className={styles.eyebrow}>Por qué Britosa</span>
              <h2>Más de dos décadas cuidando tus recuerdos</h2>
              <p className={styles.lead}>
                No movemos cajas. Movemos historias, memorias y nuevos comienzos.
                Por eso cada mudanza es personal, aunque sea la número mil.
              </p>
              <ul className={styles.reasonList}>
                <li><FaCheckCircle /> Equipo propio y formado</li>
                <li><FaCheckCircle /> Seguro a todo riesgo incluido</li>
                <li><FaCheckCircle /> Presupuesto cerrado, sin sorpresas</li>
                <li><FaCheckCircle /> Disponibilidad todos los días 8:00–22:00</li>
              </ul>
            </div>
            <div className={styles.reasonImage}>
              <img src="/assets/images/carousel-3.webp" alt="Llaves de nuevo hogar" />
            </div>
          </div>
        </div>
      </section>

      <section className={styles.finalCta}>
        <div className={styles.container}>
          <div className={styles.finalCtaBox}>
            <img src="/assets/images/logo-icon.png" alt="Britosa" className={styles.ctaLogo} />
            <h2>¿Empezamos?</h2>
            <p>Pide tu presupuesto personalizado en menos de 2 minutos.</p>
            <div className={styles.finalCtaButtons}>
              <Link to="/presupuesto" className={styles.btnPrimary}>
                Pedir presupuesto <FaArrowRight />
              </Link>
              <a href="tel:+34691604880" className={styles.btnGhostDark}>
                <FaPhone /> Llamar ahora
              </a>
            </div>
            <ShareButtons title="Britosa Mudanzas Madrid" url="https://mudanzasbritosa.com/" />
          </div>
        </div>
      </section>

    </div>
  );
}
